import { Component } from 'san';
import * as _ from 'lodash';
import { IProject, IUploaderErrorResponse, IUser } from 'src/models';
import uploaderService from 'src/services/uploader.service';
import userService from 'src/services/user.service';
import toasterService from 'src/services/toaster.service';
export default class Project extends Component {
    constructor(options: any) {
        super(options);
    }

    initData(): {
        isShow: boolean;
        currentUser: IUser;
        auditId: string;
        batchUploadCallback: (batchUploadEle: any) => void;
        file: any;
        errorsList: { row: number; error: string }[];
        isUpload: boolean;
        href: string;
    } {
        return {
            isShow: false,
            currentUser: undefined,
            auditId: '',
            batchUploadCallback: null,
            file: undefined,
            errorsList: [],
            isUpload: false,
            href: '',
        };
    }

    show() {
        this.data.set('isShow', true);
        this.fire('show-change', true);
    }

    attached() {
        userService.getCurrentUser().then((currentUser) => {
            this.data.set('currentUser', currentUser);
            this.initBatchUpload(this.data.get('auditId'), currentUser.user_id);
            this.initHref(currentUser);
        });
    }

    initHref(currentUser: IUser) {
        this.data.set('href', `/api/files/templates/0?uid=${currentUser.user_id}`);
    }

    initBatchUpload(auditId: string, currentUserId: string) {
        uploaderService.show({
            auto: false,
            isMultiple: false,
            selector: '#batchUpload',
            dnd: '#chooseFile', // 可拖拽上传
            server: `/api/files/import-projects?audit_id=${auditId}&user_id=${currentUserId}`,
            startUploadDisabled: true,
            queuedCallback: (file) => {
                this.data.set('file', file);
            },
            successCallback: (projects: IProject[]) => {
                this.fire('upload-success', projects);
                this.cancel();
            },
            errorCallback: (response: IUploaderErrorResponse) => {
                this.data.set('isUpload', false);
                if (!response.error_models && response.message) {
                    toasterService.show({
                        type: 'danger',
                        title: response.message,
                    });
                    this.data.set('errorsList', []);
                    return;
                }
                if (response.error_models && _.includes(_.keys(response.error_models), '-1')) {
                    toasterService.show({
                        type: 'danger',
                        title: response.message,
                        contents: [response.error_models['-1']],
                    });
                    this.data.set('errorsList', []);
                    return;
                }
                const list = [];
                _.forEach(_.keys(response.error_models), (key) => {
                    list.push({
                        row: key,
                        error: _.join(response.error_models[key], ';'),
                    });
                });
                this.data.set('errorsList', list);
            },
        });
    }

    chooseFile() {
        const batchUploadEle = $(`#batchUpload input[type='file']`);
        batchUploadEle.click();
        this.data.set('errorsList', []);
    }

    reChooseFile() {
        if (this.data.get('file')?.id) {
            uploaderService.removeFile('#batchUpload', this.data.get('file').id);
        }
        const batchUploadEle = $(`#batchUpload input[type='file']`);
        batchUploadEle.click();
        this.data.set('errorsList', []);
    }

    // 导入
    batchUpload() {
        this.data.set('isUpload', true);
        this.data.set('file', undefined);
        this.updateAuditIdSync();
        setTimeout(() => {
            // 导入（上传前需暂存）
            const batchUploadCallback = this.data.get('batchUploadCallback');
            if (batchUploadCallback) {
                batchUploadCallback();
            }
        }, 600);
    }

    // 更新auditId，并更新文件上传server地址
    updateAuditIdSync() {
        const auditId = this.data.get('auditId');
        const currentUserId = this.data.get('currentUser').user_id;
        const projectToUploadSub = this.data.get('projectToUploadSub');
        let serverUrl = `/api/files/import-projects?audit_id=${auditId}&user_id=${currentUserId}`;
        if (projectToUploadSub) {
            serverUrl += `&puid=${projectToUploadSub.puid}`;
        }
        uploaderService.updateServerUrl('#batchUpload', serverUrl); // 更新文件上传server地址
    }

    cancel() {
        this.data.set('isShow', false);
        this.data.set('errorsList', []);
        this.fire('show-change', false);
        this.data.set('isUpload', false);
        if (this.data.get('file')?.id) {
            uploaderService.removeFile('#batchUpload', this.data.get('file').id);
            this.data.set('file', undefined);
        }
    }
}
